<template>
    <div class="emb-contact-wrap">
        <div class="section-gap primary pb-5">
            <v-container grid-list-xl py-0>
                <v-layout row wrap align-center justify-center text-center text-sm-center text-xl-left text-lg-left>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="subscribe-content">
                            <h1 class="translate-top white--text">
                                ¡Descargar herramienta para soporte!
                            </h1>
                            <p class="translate-right white--text">
                                Usa la tecnología para alcanzar los objetivos de tu negocio ¡No busques más!
                            </p> 
                            <v-btn color="accent" rounded href="https://download.anydesk.com/AnyDesk.exe" target="_new">Descargar Anydesk</v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="subscribe-content">
                            <div class="emb-aside-banner-v1 text-right">
                                <img class="emb-card" alt="aside-banner" src="/static/images/functionalities.jpg" width="547" height="315" />
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <!-- <div class="emb-contact-content">
            <div class="contact-info-wrapper">
                <v-container grid-list-xl py-0>
                    <h2>Pasos a seguir</h2>
                </v-container>
                <p></p>
            </div>
        </div> -->
    </div>
</template>

<script>
import api from 'Api';

export default {
    data() {
        return {
            valid: false,
            contactInfo: '',
            emailRules: [(v) => !!v || 'E-mail is required', (v) => /.+@.+/.test(v) || 'E-mail must be valid'],
            inputRules: {
                basictextRules: [(v) => !!v || 'Requerido'],
            },
        };
    },
    beforeCreate() {
		document.title = "Soporte | Sislii";
    },
    methods: {
        getContactInfo() {
            api.get('contact.json')
                .then((response) => {
                    this.contactInfo = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        saveDetails() {
            this.$refs.form.validate();
        },
    },
};
</script>
